export default [
	{
		path: '/',
		component: () => import('./views/commons/Home/index')
	},
	{
		path: '/cadastro',
		component: () => import('./views/commons/Cadastro/index')
	},
	{
		path: '/votacao',
		component: () => import('./views/commons/Home/index')
	}
];